import { useContent } from "@/context/ContentContext";
import Press from "@/components/site/Press";
import PageLoader from "@/components/site/PageLoader";

export default function PressPage() {
  const c = useContent();
  if (!c) return <PageLoader />;
  return <Press items={c.press || []} />;
}
